import { Button } from "primereact/button";

/** ⊕ de la fila de alta. Siempre habilitado: si falta un dato, marca el campo y no agrega. */
export function AddRowButton({ label, onClick, loading }: { label: string; onClick: () => void; loading?: boolean }) {
    return (
        <Button
            type="button"
            text
            className="nv-icon nv-tip"
            icon="pi pi-plus-circle"
            aria-label={label}
            data-pr-tooltip={label}
            loading={loading}
            onClick={onClick}
        />
    );
}

/** Leyenda de error debajo de un campo (marcador en el campo). */
export function FieldError({ id, message }: { id: string; message?: string }) {
    if (!message) return null;
    return (
        <small id={id} className="p-error">
            <i className="pi pi-exclamation-triangle" aria-hidden /> {message}
        </small>
    );
}
